import { DataGridProps, GridPaginationModel, GridValidRowModel } from '@mui/x-data-grid'
import { useState } from 'react'

export default function useDataGrid<T extends GridValidRowModel>({
  paginationModel,
  pageSizeOptions,
  onPaginationModelChange,
  ...props
}: Partial<DataGridProps<T>> = {}): Partial<DataGridProps> {
  const [defaultPaginationModel, setDefaultPaginationModel] = useState<GridPaginationModel>({
    pageSize: 24,
    page: 0
  })

  const defaultPageSizeOptions = [6, 12, 24, 48, 96]

  function handlePaginationModelChange(model: GridPaginationModel) {
    setDefaultPaginationModel(model)
  }

  return {
    paginationModel: paginationModel ?? defaultPaginationModel,
    pageSizeOptions: pageSizeOptions ?? defaultPageSizeOptions,
    onPaginationModelChange: onPaginationModelChange ?? handlePaginationModelChange,
    ...props
  }
}
